const getFeatureToggles = (state) => state.featureToggles;
export {
  getFeatureToggles
};
//# sourceMappingURL=selectors.js.map
